import moment from "moment";
import _ from "lodash";

export const getYears = data => {
  let _data = _.cloneDeep(data);
  return _.uniq(_data.map(item => moment(item.showStartTime).format("YYYY")));
};

export const getMonths = (data, year) => {
  let _data = _.cloneDeep(data);
  let curYearData = _data.filter(data => moment(data.showStartTime).format("YYYY") === year);
  return _.uniq(curYearData.map(data => moment(data.showStartTime).month()));
};

export const getDays = (data, month) => {
  let _data = _.cloneDeep(data);
  let curMonthData = _data.filter(data => moment(data.showStartTime).month() === month);
  return _.uniq(curMonthData.map(data => moment(data.showStartTime).date()));
}